import { type ApiClientError, ApiClientErrorResponse } from '~/ApiClient';

import { ErrorCode, InvalidValue, QueryErrors } from './validateQuery';

const createInvalidConditionFilter = (parameterName: string) => (error: ApiClientError) => {
	return error.code === 'request-validation-error' && error.source !== null && error.source.parameter === parameterName;
};

export default class ProductsErrorResponse extends ApiClientErrorResponse {
	handleSearchInvalidAtcCondition(): boolean {
		return this.handleWith(createInvalidConditionFilter('filter-atc'));
	}

	handleSearchInvalidCountryCondition(): boolean {
		return this.handleWith(createInvalidConditionFilter('filter-country'));
	}

	handleSearchInvalidDatasourceCondition(): boolean {
		return this.handleWith(createInvalidConditionFilter('filter-datasource'));
	}

	handlePaginationLimit(): boolean {
		return this.handle('product-search-pagination-limit');
	}

	handleQueryErrors(): QueryErrors {
		const errors: { [key: string]: ErrorCode[] } = {};
		if (this.handleSearchInvalidAtcCondition()) {
			errors.atc = [InvalidValue];
		}
		if (this.handleSearchInvalidCountryCondition()) {
			errors.country = [InvalidValue];
		}
		return errors;
	}
}
